<script setup lang="ts">
import { Head } from "@inertiajs/vue3"
import { SbList } from "@unio/saltbox-ui"
import { ref } from "vue"

import EmptyState from "@/components/EmptyState.vue"
import IndexHeader from "@/components/IndexHeader.vue"
import NarrowPage from "@/components/NarrowPage.vue"
import SearchInput from "@/components/SearchInput.vue"
import TagFormSlideover from "@/components/TagFormSlideover.vue"
import TagListItem from "@/components/TagListItem.vue"
import { useNavbar } from "@/composables/useNavbar"
import { useSearchableIndex } from "@/composables/useSearchableIndex"
import { ICON } from "@/lib/icons"
import { tagsPath } from "@/routes"
import type { TagSummary } from "@/types/models"

const { title } = useNavbar({ title: "Tags" })

interface Props {
  tags: TagSummary[]
  query: string
  colors: string[]
}

const props = defineProps<Props>()

const { search } = useSearchableIndex(props.query, tagsPath)
const slideoverOpen = ref(false)
</script>

<template>
  <Head :title="title" />

  <NarrowPage>
    <IndexHeader
      :count="tags.length"
      noun="tag"
      button-label="New Tag"
      @action="slideoverOpen = true"
    />

    <SearchInput v-model="search" placeholder="Search tags..." />

    <SbList v-if="tags.length" bordered separator>
      <TagListItem v-for="tag in tags" :key="tag.id" :tag="tag" />
    </SbList>

    <EmptyState v-else :icon="ICON.tag" noun="tags" :query="query" />
  </NarrowPage>

  <TagFormSlideover v-model:open="slideoverOpen" :colors="colors" :tag="null" />
</template>
